'use strict';

var cov_1286eelyjw = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/datepicker/datepicker.component.js',
      hash = 'ce141a4ec25a6b019957802bd1915a3834d29519',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/datepicker/datepicker.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 31
        }
      },
      '2': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 24
        }
      },
      '3': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 12,
          column: 6
        }
      },
      '4': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 18,
          column: 5
        }
      },
      '5': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 28
        }
      },
      '6': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      '7': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 52
        }
      },
      '8': {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 24
        }
      },
      '9': {
        start: {
          line: 34,
          column: 17
        },
        end: {
          line: 34,
          column: 56
        }
      },
      '10': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '11': {
        start: {
          line: 41,
          column: 0
        },
        end: {
          line: 52,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 13,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 19,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 27,
            column: 3
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 26
          },
          end: {
            line: 38,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatepickerComponent = function () {
  function DatepickerComponent(moment) {
    _classCallCheck(this, DatepickerComponent);

    ++cov_1286eelyjw.f[0];
    ++cov_1286eelyjw.s[0];

    this.moment = moment;
  }

  _createClass(DatepickerComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_1286eelyjw.f[1];
      ++cov_1286eelyjw.s[1];

      this.format = "dd/MM/yyyy";
      ++cov_1286eelyjw.s[2];
      this.isOpen = false;
      ++cov_1286eelyjw.s[3];
      this.options = {
        startingDay: 1,
        showWeeks: false
      };
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      ++cov_1286eelyjw.f[2];
      ++cov_1286eelyjw.s[4];

      if (changes.value.currentValue) {
        ++cov_1286eelyjw.b[0][0];
        ++cov_1286eelyjw.s[5];

        this.parseInputDate();
      } else {
        ++cov_1286eelyjw.b[0][1];
      }
    }
  }, {
    key: 'parseInputDate',
    value: function parseInputDate() {
      ++cov_1286eelyjw.f[3];
      ++cov_1286eelyjw.s[6];

      if (this.value) {
        ++cov_1286eelyjw.b[1][0];
        ++cov_1286eelyjw.s[7];

        this.value = this.moment(this.value).toDate();
      } else {
        ++cov_1286eelyjw.b[1][1];
        ++cov_1286eelyjw.s[8];

        this.value = null;
      }
    }

    /**
     * Ecoute changemrnt de date.
     */

  }, {
    key: 'listenDateChange',
    value: function listenDateChange(value) {
      ++cov_1286eelyjw.f[4];

      var date = (++cov_1286eelyjw.s[9], this.moment(value).format('YYYY-MM-DD'));
      ++cov_1286eelyjw.s[10];
      this.onChange({
        value: date
      });
    }
  }]);

  return DatepickerComponent;
}();

++cov_1286eelyjw.s[11];


angular.module('app').component('datepicker', {
  bindings: {
    value: '<',
    options: '<',
    placeholder: '@',
    onChange: '&'
  },
  templateUrl: 'app/components/datepicker/datepicker.template.html',
  controller: DatepickerComponent
});